import { ElementRef, OnInit, QueryList } from '@angular/core';
import { Validators } from "@angular/forms";
import { PHONE_MASK } from "../../config/country_phone_mask";
import * as i0 from "@angular/core";
import * as i1 from "../../modules/auth/_services/authentication.service";
import * as i2 from "@angular/forms";
import * as i3 from "../../service/login.service";
import * as i4 from "@angular/router";
import * as i5 from "../../service/loader.service";
import * as i6 from "../../service/session/sessionStorage.service";
import * as i7 from "../../shared/popup/popup.component";
var LoginComponent = /** @class */ (function () {
    function LoginComponent(authenticationService, formBuilder, loginService, router, loaderService, activatedRoute, sessionStorageService, popupComponent) {
        this.authenticationService = authenticationService;
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.router = router;
        this.loaderService = loaderService;
        this.activatedRoute = activatedRoute;
        this.sessionStorageService = sessionStorageService;
        this.popupComponent = popupComponent;
        this.partnerLogo = '../assets/images/logo.png';
        this.phoneMask = PHONE_MASK.us;
        this.numOfDigits = 4;
        this.isPinPopupShown = false;
        this.isPromoCodeRequire = false;
        this.activeForm = null;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.authenticationService.logout();
        this.userForm = this.formBuilder.group({
            phone: [null, Validators.required]
        });
        this.userFormSecond = this.formBuilder.group({
            phone: [null, Validators.required]
        });
        this.userPinForm = this.formBuilder.group({
            promoCode: [null],
            digits: this.formBuilder.array([])
        });
        for (var i = 0; i < this.numOfDigits; i++) {
            this.userPinForm.get('digits').push(this.formBuilder.control(null, Validators.required));
        }
    };
    LoginComponent.prototype.onPhoneSubmit = function (form) {
        var _this = this;
        if (form) {
            this.activeForm = form;
        }
        if (!this.activeForm || this.activeForm.controls.phone.invalid) {
            return;
        }
        var phone = this.activeForm.controls.phone.value;
        this.authenticationService.checkPhoneAndSendPin(phone).subscribe(function (data) {
            try {
                if (data.status) {
                    _this.isPromoCodeRequire = !!data.promoCode;
                    // this.isPromoCodeRequire = true;
                    _this.showPinForm();
                }
                else {
                    _this.popupComponent.showPopupError({ text: data.message });
                }
            }
            catch (e) {
                _this.loaderService.hideAndShowTryAgain();
            }
        }, function (error) {
            _this.loaderService.hideAndShowTryAgain();
        }, function () {
            _this.loaderService.hide();
        });
    };
    LoginComponent.prototype.showPinForm = function () {
        var _this = this;
        this.isPinPopupShown = true;
        setTimeout(function () {
            if (_this.isPromoCodeRequire) {
                _this.promoCode.nativeElement.focus();
            }
            else {
                _this.inputs.toArray()[0].nativeElement.focus();
            }
        });
    };
    LoginComponent.prototype.check = function (index, field, event) {
        if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
            event.preventDefault();
        }
        if (field.value && event.key !== 'Backspace') {
            if (index < this.inputs.toArray().length - 1) {
                this.inputs.toArray()[index + 1].nativeElement.focus();
            }
        }
        else if (event.key === 'Backspace') {
            if (index > 0) {
                field.setValue(null);
                this.inputs.toArray()[index - 1].nativeElement.focus();
            }
            else {
                console.log('first field');
            }
        }
    };
    LoginComponent.prototype.onUserFormSubmit = function () {
        var _this = this;
        if ((this.userForm.invalid && this.userFormSecond.invalid) || this.userPinForm.invalid) {
            return;
        }
        var phone = this.activeForm.controls.phone.value;
        var promoCode = this.userPinForm.controls.promoCode.value;
        var pin = this.userPinForm.controls.digits.value;
        pin = pin.join('');
        if (pin.length !== 4) {
            this.popupComponent.showPopupError({ text: 'The Code should consist of 4 numerical characters' });
            return;
        }
        if (phone && pin && (pin.length === 4)) {
            this.authenticationService.login(phone, pin, promoCode).subscribe(function (data) {
                _this.checkLoginSubmit(data);
            }, function (error) {
                _this.loaderService.hideAndShowTryAgain();
            }, function () {
                _this.loaderService.hide();
            });
        }
        else {
            this.loaderService.hideAndShowTryAgain();
        }
    };
    LoginComponent.prototype.checkLoginSubmit = function (data) {
        try {
            if (data.status) {
                //this.popupComponent.showPopupSuccess({text: data.message});
                this.goToHomePage();
            }
            else {
                this.popupComponent.showPopupError({ text: data.message });
            }
        }
        catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    };
    LoginComponent.prototype.getAppLink = function () {
        return this.sessionStorageService.getAppLink() + '/senetpro?token=' + this.sessionStorageService.getUserToken();
    };
    LoginComponent.prototype.goToHomePage = function () {
        var _this = this;
        setTimeout(function () {
            _this.loaderService.show();
        });
        window.location.href = this.getAppLink();
    };
    LoginComponent.prototype.resetPinInput = function () {
        this.userPinForm.get('digits').clear();
        for (var i = 0; i < this.numOfDigits; i++) {
            this.userPinForm.get('digits').push(this.formBuilder.control(null, Validators.required));
        }
    };
    LoginComponent.prototype.onResend = function () {
        this.onPhoneSubmit();
        this.resetPinInput();
    };
    LoginComponent.prototype.goBack = function () {
        this.isPinPopupShown = false;
        this.isPromoCodeRequire = false;
        this.resetPinInput();
        this.activeForm = null;
        this.userPinForm.controls.promoCode.reset();
    };
    LoginComponent.prototype.closePopup = function ($event) {
        this.goBack();
    };
    LoginComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginComponent_Factory() { return new LoginComponent(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.FormBuilder), i0.ɵɵinject(i3.LoginService), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i5.LoaderService), i0.ɵɵinject(i4.ActivatedRoute), i0.ɵɵinject(i6.SessionStorageService), i0.ɵɵinject(i7.PopupComponent)); }, token: LoginComponent, providedIn: "root" });
    return LoginComponent;
}());
export { LoginComponent };
